import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WainScoutingPanel.css';
import SEO from '../../components/SEO';
import wainscotingProject1 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11 (1).jpeg";
import wainscotingProject2 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11 (2).jpeg";
import wainscotingProject3 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.11.jpeg";
import wainscotingProject4 from "../../assets/Wainscoting panels design's/WhatsApp Image 2026-05-10 at 18.14.12.jpeg";

const WainScoutingPanel = () => {
  const navigate = useNavigate();
  const panelTypes = [
    {
      title: '1 Inch Panels',
      description: 'Subtle and sleek for minimalist modern designs.'
    },
    {
      title: '1.5 Inch Panels',
      description: 'Balanced profile for versatile decorative applications.'
    },
    {
      title: '2 Inch Panels',
      description: 'Bold, pronounced detailing for statement walls.'
    }
  ];

  const applications = [
    'Living Rooms',
    'Bedrooms',
    'Dining Areas',
    'Office Spaces',
    'Hotel Interiors',
    'Hallways & Corridors'
  ];

  const benefits = [
    'Enhances interior aesthetics',
    'Protects walls from damage',
    'Easy to maintain and clean',
    'Adds value to your property',
    'Customizable designs and finishes'
  ];

  const processSteps = [
    'Consultation & Design Planning',
    'Material Selection',
    'Custom Fabrication',
    'Professional Installation',
    'Final Finishing & Inspection'
  ];

  const faqs = [
    {
      question: 'What is the purpose of wainscoting panels?',
      answer: 'They enhance wall aesthetics while protecting surfaces from damage.'
    },
    {
      question: 'Are wainscoting panels suitable for modern interiors?',
      answer: 'Yes, modern styles like flat panel and board & batten fit perfectly in contemporary spaces.'
    },
    {
      question: 'What materials are used for wall scoting panels?',
      answer: 'MDF, wood, PVC, and gypsum-based materials.'
    },
    {
      question: 'How much do wainscoting panels cost?',
      answer: 'Costs vary depending on design, materials, and space size.'
    }
  ];

  const wainscotingProjects = [
    {
      src: wainscotingProject1,
      alt: 'Wainscoting panel installation — decorative wall panels by Techie Interiors'
    },
    {
      src: wainscotingProject2,
      alt: 'Modern wainscoting and wall paneling design'
    },
    {
      src: wainscotingProject3,
      alt: 'Interior wall panel feature with wainscoting'
    },
    {
      src: wainscotingProject4,
      alt: 'Custom wainscoting panels project Kenya'
    }
  ];

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    "serviceType": "Wainscoting Panel Installation",
    "provider": {
      "@type": "LocalBusiness",
      "name": "Techie Interiors",
      "telephone": "+254748600208",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressCountry": "KE"
      }
    },
    "areaServed": "Kenya",
    "description": "Professional wainscoting panel installation in Nairobi Kenya. Decorative wall paneling for homes, offices, and hotels with custom designs and finishes."
  };

  return (
    <div className="wainscoting-page">
      {/* SEO Component */}
      <SEO
        title="Wainscoting & Decorative Wall Panels Installation Kenya | Techie Interiors"
        description="Expert wainscoting panel installation in Nairobi Kenya. Raised panel, beadboard, board and batten, and custom decorative wall paneling for residential and commercial spaces."
        keywords="wainscoting panels Nairobi, wall paneling Kenya, decorative wall panels, raised panel wainscoting, beadboard panels Kenya, interior wall paneling Nairobi, custom wall paneling, wall panel installation, decorative wall panels, acoustic wall panels, PVC wall panels, 3D wall panel designs, modern feature walls, interior wall cladding, luxury wall finishes, stone wall interior designs, wood panel wall designs, professional installation, durable finishes, modern designs, luxury interiors, residential spaces, commercial buildings, Nairobi, Kenya, affordable pricing, transparent quotes, reliable service, experienced craftsmen, high-quality materials, durable construction, space-saving designs, tailored to your needs, Techie Interiors"
        image="/techLogo.jpeg"
        url="https://techieinteriors.co.ke/wain-scouting"
        structuredData={structuredData}
      />
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1>Premium Wainscoting Panels & Wall Scoting Solutions</h1>
          <p>Transform your interiors with elegant, durable, and custom-designed wainscoting panels for homes, offices, and commercial spaces.</p>
          <div className="hero-cta">
            <button className="btn-primary" onClick={() => navigate('/services')}>Get a Free Quote</button>
            <button className="btn-secondary" onClick={() => navigate('/project')}>View Our Designs</button>
          </div>
        </div>
      </section>

      {/* Introduction Section */}
      <section className="intro-section">
        <div className="container">
          <h2>What Are Wainscoting Panels?</h2>
          <p>Wainscoting panels, also known as wall scoting panels, are decorative wall coverings installed on the lower half of interior walls to enhance aesthetics and protect surfaces. At Techie Interiors, we design and install modern and classic wainscoting panels tailored to your space.</p>
          <p>Elevate your walls with stylish wainscoting panels designed to add depth,
             texture, and elegance to any interior space. Ideal for living rooms, bedrooms, hallways, offices, and feature walls, our panels create a modern decorative finish that transforms plain walls into standout design elements.</p>
        </div>
      </section>

      {/* Types of Wainscoting Panels */}
      <section className="panel-types-section">
        <div className="container">
          <h2>Our types of Wainscoting Panel Designs are : </h2>
          <div className="panel-grid">
            {panelTypes.map((panel, index) => (
              <div key={index} className="panel-card">
                <div className="panel-icon">✔</div>
                <h3>{panel.title}</h3>
                <p>{panel.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Applications Section */}
      <section className="applications-section">
        <div className="container">
          <h2>Where to Use Wainscoting Panels</h2>
          <div className="applications-grid">
            {applications.map((app, index) => (
              <div key={index} className="application-item">
                {app}
              </div>
            ))}
          </div>
          <p className="applications-text">Our wainscoting panels are versatile and enhance both residential and commercial interiors with a refined and modern touch.</p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="benefits-section">
        <div className="container">
          <h2>Why Choose Wainscoting Panels?</h2>
          <div className="benefits-list">
            {benefits.map((benefit, index) => (
              <div key={index} className="benefit-item">
                <span className="check-icon">✓</span>
                <span>{benefit}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Process */}
      <section className="process-section">
        <div className="container">
          <h2>Our Installation Process</h2>
          <div className="process-steps">
            {processSteps.map((step, index) => (
              <div key={index} className="process-step">
                <div className="step-number">{index + 1}</div>
                <div className="step-content">{step}</div>
              </div>
            ))}
          </div>
          <p className="trust-line">We ensure precision and high-quality craftsmanship in every project.</p>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="gallery-section">
        <div className="container">
          <h2>Our Recent Wainscoting Projects</h2>
          <div className="gallery-grid">
            {wainscotingProjects.map((project, index) => (
              <figure key={project.src || index} className="gallery-item">
                <img
                  src={project.src}
                  alt={project.alt}
                  loading="lazy"
                  decoding="async"
                />
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container">
          <h2>What Our Clients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-card">
              <p>"Exceptional quality of finish that transformed our living room completely."</p>
              <div className="client-name">- Sarah M.</div>
            </div>
            <div className="testimonial-card">
              <p>"Professional installation team that completed the project on time and within budget."</p>
              <div className="client-name">- James K.</div>
            </div>
            <div className="testimonial-card">
              <p>"The design options were amazing and the final result exceeded our expectations."</p>
              <div className="client-name">- Emily R.</div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-section">
        <div className="container">
          <h2>Frequently Asked Questions About Wainscoting Panels</h2>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div key={index} className="faq-item">
                <h3> {faq.question}</h3>
                <p> {faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <h2>Upgrade Your Walls with Elegant Wainscoting Panels</h2>
          <p>Ready to transform your interior with premium wall paneling? Contact Techie Interiors today for custom wainscoting solutions.</p>
          <div className="cta-buttons">
            <button className="btn-primary" onClick={() => navigate('/services')}>Request a Quote</button>
            <button className="btn-secondary" onClick={() => navigate('/contact-us')}>Contact Us</button>
          </div>
        </div>
      </section>

      {/* SEO Footer Content */}
      <section className="seo-footer">
        <div className="container">
          <p>We provide high-quality wainscoting panels, wall scoting solutions, and decorative wall paneling services tailored to modern interiors. Whether you are looking for classic wainscoting designs, custom wall panels, or stylish interior finishes, Techie Interiors delivers unmatched craftsmanship and detail.</p>
        </div>
      </section>
    </div>
  );
};

export default WainScoutingPanel;